export default function getPlayOrder() {
  const order = [0, 1, 2, 3, 4, 5, 6, 7, 8];

  order.sort(() => 0.5 - Math.random());

  return order;
}
